export default __webpack_public_path__ + "static/media/chevron-down_sm.697f08ea.svg";